import { gql } from "@apollo/client";

export const BATCH_MARK_SUSPECTED_MISSING = gql`
    mutation BatchMarkSuspectedMissing(
        $orderIds: [Long!]!, 
        $exceptionHubId: Long!,
        $exceptionWarehouseId: Long,
        $batchSize: Int
    ) {
        batchMarkSuspectedMissing(
            orderIds: $orderIds, 
            exceptionHubId: $exceptionHubId,
            exceptionWarehouseId: $exceptionWarehouseId,
            batchSize: $batchSize
        )
    }
`;

export interface BatchMarkSuspectedMissingInput {
    orderIds: string[];
    exceptionHubId: string | number;
    exceptionWarehouseId?: string;
    batchSize?: number;
}